const createPayload = (type, post, payload) => ({_ajax: true, post, type, ...payload});
const createGlobalPayload = (type, post, payload) => ({_ajax: true, post, global: true, type, ...payload});

export default createPayload;

export { createPayload, createGlobalPayload };